import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './index.styled';

const LogoSloganComponent = ({ handleClick, type, className }) => {
  return <Container className={className} onClick={handleClick} type={type} />;
};

LogoSloganComponent.propTypes = {
  handleClick: PropTypes.func,
  type: PropTypes.oneOf(['white', 'color']),
  className: PropTypes.string,
};

LogoSloganComponent.defaultProps = {
  handleClick: () => {},
  type: 'white',
  className: '',
};

export default LogoSloganComponent;
